<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 智慧物业轮播图 -->
    <PropertyBanner></PropertyBanner>
    <!-- 行业痛点 -->
    <Painpoint></Painpoint>
    <!-- 智能化物业管理体系 -->
    <PropertySystem></PropertySystem>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import PropertyBanner from '../../../../components/pc/Programme/PropertyComponents/PropertyBanner.vue'
import Painpoint from '../../../../components/pc/Product/AdminSystemComponents/Painpoint.vue'
import PropertySystem from '../../../../components/pc/Programme/PropertyComponents/PropertySystem.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    PropertyBanner,
    Painpoint,
    PropertySystem,
  },
};
</script>

<style scoped>

</style>
